import type {ComponentProps} from 'react';
import classNames from 'classnames';

import {Image} from '../../../atoms/image';

import {FilePreview} from './file-preview';

import styles from './image-preview.module.css';

type Props = Omit<ComponentProps<typeof FilePreview>, 'children'> & {

    /**
   * URL изображения для просмотра
   */
    imageUrl: string;

    width: number;

    height: number;
};

export const ImagePreview = ({imageUrl, className, ...props}: Props) => (
    <FilePreview {...props} className={classNames(styles.root, className)}>
        <Image src={imageUrl} className={styles.image} />
    </FilePreview>
);
